import React from 'react';
import { DatePicker } from 'antd';
import DateFilter from './DateFilter';
import styles from './styles/date-filters.module.scss';

const { RangePicker } = DatePicker;

function DateFilters({ activeTimeFrame, onTimeFrameChange, onDateRangeChange }) {
    const timeFrameOptions = [
        { label: 'All Time', value: 'all' },
        { label: 'Last Week', value: '7d' },
        { label: 'Last Month', value: '30d' },
        { label: 'Custom', value: 'custom' },
    ];

    const [showDatePicker, setShowDatePicker] = React.useState(false);

    const handleTimeFrameChange = async (value) => {
        setShowDatePicker(value === 'custom');
        await onTimeFrameChange(value);
    };

    return (
        <div className={styles.dateFilters}>
            {timeFrameOptions.map((data) => (
                <DateFilter text={data.label} selected={activeTimeFrame === data.value} onClick={async () => await handleTimeFrameChange(data.value)} />
            ))}
            {showDatePicker && (
                <div>
                    <RangePicker onChange={onDateRangeChange} />
                </div>
            )}
        </div>
    );
}

export default DateFilters;
